import React from "react";

export default function TableList({
  tables,
  searchQuery,
  handleSearchChange,
  handletable,
  pendingTable,
  hideAvailableTables,
  bottomContainerRef,
  handleScroll,
}) {
  return (
    <div
      className={`bottom-container ${hideAvailableTables ? "hidden" : ""}`}
      ref={bottomContainerRef}
      onScroll={handleScroll}
    >
      <div className="d-flex available-tables flex-column justify-content-between mb-3">
        <h6 className="bold-text">Available Tables</h6>
        <input
          type="text"
          placeholder="Search Table"
          className="table-search-box rounded-4 ps-2 py-1 w-100"
          value={searchQuery}
          onChange={handleSearchChange}
        />
      </div>

      <div className="table-card-container">
        {tables.length > 0 ? (
          tables.map((table) => (
            <div key={table.tableId}>
              <div
                className={`table-card text-cursor-pointer d-flex ${
                  pendingTable?.tableId === table.tableId
                    ? "selected-table-card"
                    : ""
                }`}
                onClick={() => handletable(table)}
              >
                <div className="table-card-body w-75">
                  <h5 className="table-card-title">{table.tableName}</h5>
                  <p className="table-card-text mb-0">{table.description}</p>
                  <p className="table-card-text mb-0">
                    Available seat: {table.totalChairUnderThisTable}
                  </p>
                </div>

                <div className="table-card-img-container">
                  <img
                    src={table.tableImagePath}
                    className="table-card-img"
                    alt={table.tableName}
                  />
                </div>
              </div>
              <hr />
            </div>
          ))
        ) : (
          <h6 className="text-center">No Table Data Available</h6>
        )}
      </div>
    </div>
  );
}
